import { render, staticRenderFns } from "./verNovedadesDelivery.vue?vue&type=template&id=2f08244e&scoped=true"
import script from "./verNovedadesDelivery.vue?vue&type=script&lang=js"
export * from "./verNovedadesDelivery.vue?vue&type=script&lang=js"
import style0 from "./verNovedadesDelivery.vue?vue&type=style&index=0&id=2f08244e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08244e",
  null
  
)

export default component.exports